<!-- Breakthrough Incidents Analysis Slideout -->
<div class="breakthrough-analysis-container">
  <!-- Header -->
  <div class="analysis-header">
    <div class="header-content">
      <h2 class="analysis-title">Breakthrough Incidents Analysis</h2>
      <p
        class="analysis-subtitle"
        *ngIf="analysisData"
      >
        {{ analysisData.total_breakthrough_incidents }} incidents that bypassed security controls
      </p>
    </div>
    <button
      class="btn-close"
      type="button"
      [attr.aria-label]="'Close'"
      (click)="onClose()"
    >
      <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
    </button>
  </div>

  <!-- Loading State -->
  <div
    *ngIf="isLoading"
    class="loading-container"
  >
    <div class="loading-spinner"></div>
    <p>Loading analysis data...</p>
  </div>

  <!-- Analysis Content -->
  <div
    *ngIf="!isLoading && analysisData"
    class="analysis-content"
  >
    <!-- Summary Stats Box -->
    <div class="summary-stats-box">
      <div class="stat-item">
        <div class="stat-label">Total Breakthrough Incidents</div>
        <div class="stat-value">{{ analysisData.total_breakthrough_incidents | number }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">vs Previous Period</div>
        <div
          class="stat-value"
          [class.positive]="analysisData.percentage_change > 0"
          [class.negative]="analysisData.percentage_change < 0"
        >
          <span *ngIf="analysisData.percentage_change > 0">↑</span>
          <span *ngIf="analysisData.percentage_change < 0">↓</span>
          {{ analysisData.percentage_change | number: '1.1-1' }}%
        </div>
      </div>
    </div>

    <!-- Attack Pattern Analysis Section -->
    <div class="analysis-section">
      <h3 class="section-title">Attack Pattern Analysis</h3>

      <!-- Sender Domains Patterns -->
      <div class="pattern-category">
        <h4 class="category-title">Sender Domain Patterns</h4>
        <div class="pattern-grid">
          <div
            class="pattern-item"
            *ngFor="let pattern of analysisData.sender_domain_patterns"
          >
            <div class="pattern-label">{{ pattern.type }}</div>
            <div class="pattern-stats">
              <span class="pattern-count">{{ pattern.count | number }}</span>
              <span class="pattern-percentage">({{ pattern.percentage | number: '1.1-1' }}%)</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Subject Line Patterns -->
      <div class="pattern-category">
        <h4 class="category-title">Subject Line Patterns</h4>
        <div class="pattern-grid">
          <div
            class="pattern-item"
            *ngFor="let pattern of analysisData.subject_line_patterns"
          >
            <div class="pattern-label">{{ pattern.type }}</div>
            <div class="pattern-stats">
              <span class="pattern-count">{{ pattern.count | number }}</span>
              <span class="pattern-percentage">({{ pattern.percentage | number: '1.1-1' }}%)</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Attachment Type Patterns -->
      <div class="pattern-category">
        <h4 class="category-title">Attachment Type Patterns</h4>
        <div class="pattern-grid">
          <div
            class="pattern-item"
            *ngFor="let pattern of analysisData.attachment_type_patterns"
          >
            <div class="pattern-label">{{ pattern.type }}</div>
            <div class="pattern-stats">
              <span class="pattern-count">{{ pattern.count | number }}</span>
              <span class="pattern-percentage">({{ pattern.percentage | number: '1.1-1' }}%)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recommended Actions Section -->
    <div class="analysis-section">
      <h3 class="section-title">Recommended Actions</h3>

      <!-- COAI BETA Indicator -->
      <div class="ai-indicator-container">
        <div class="ai-badge-wrapper">
          <div class="ai-badge">
            <span class="ai-icon">🧠</span>
            <span class="ai-text">CASI</span>
            <span class="beta-text">BETA</span>
          </div>
        </div>
        <div class="ai-disclaimer">
          <p class="disclaimer-text">
            These recommendations are generated by CASI (CyFlare Artifical Security Intelligence). CASI may make
            mistakes - please validate recommendations before implementation.
          </p>
        </div>
      </div>

      <div class="actions-list">
        <div
          class="action-item"
          *ngFor="let action of analysisData.recommended_actions"
        >
          <div class="action-priority">
            <span
              class="priority-badge"
              [ngClass]="getPriorityClass(action.priority)"
            >
              {{ action.priority }}
            </span>
          </div>
          <div class="action-content">
            <div class="action-description">{{ action.description }}</div>
            <div class="action-impact">{{ action.estimated_impact }}</div>
            <div class="action-effort">
              <span class="effort-label">Implementation Effort:</span>
              <span
                class="effort-badge"
                [ngClass]="getEffortClass(action.implementation_effort)"
              >
                {{ action.implementation_effort }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Actions -->
  <div
    class="analysis-footer"
    *ngIf="!isLoading"
  >
    <div class="footer-actions">
      <button
        class="btn btn-outline-primary"
        (click)="exportReport()"
      >
        Export Report
      </button>
      <button
        class="btn btn-primary"
        (click)="configureRules()"
      >
        Configure Rules
      </button>
    </div>
  </div>
</div>
